import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';
import { SEND_NOTIFICATION, SEND_NOTIFICATION_ERROR, SEND_NOTIFICATION_SUCCESS } from '../../actions.js';

function* sendNotification({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/booking-notification/send`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: {
        ...payload?.data,
      },
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: SEND_NOTIFICATION_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: SEND_NOTIFICATION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SEND_NOTIFICATION_ERROR, payload: error });
  }
}

export function* watchsendNotification() {
  yield takeEvery(SEND_NOTIFICATION, sendNotification);
}

function* sendNotificationSaga() {
  yield all([fork(watchsendNotification)]);
}

export default sendNotificationSaga;
